import { useEffect, useRef } from "react";
import type { InboxItem } from "../shared/updates";
import { api } from "./api";

/** Only an explicitly opened fallback can acknowledge an unavailable source. */
export function MentionUnavailable({
  item,
  reason,
  close,
}: {
  item: InboxItem;
  reason: string;
  close: () => void;
}) {
  const host = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let started = 0,
      busy = false,
      done = false;
    const timer = setInterval(async () => {
      const element = host.current,
        bounds = element?.getBoundingClientRect();
      if (
        !element ||
        !bounds ||
        document.hidden ||
        !document.hasFocus() ||
        !element.contains(
          document.elementFromPoint(
            bounds.x + bounds.width / 2,
            bounds.y + bounds.height / 2,
          ),
        )
      ) {
        started = 0;
        return;
      }
      if (!started) started = Date.now();
      if (busy || done || Date.now() - started < 1000) return;
      busy = true;
      try {
        await api("/api/updates/read", {
          id: item.id,
          board: item.board_id,
          version: item.updated_at,
        });
        done = true;
        window.dispatchEvent(new Event("planroom:updates-read"));
      } catch {
        /* Retry while the fallback remains visible. */
      } finally {
        busy = false;
      }
    }, 250);
    return () => clearInterval(timer);
  }, [item.id, item.updated_at]);
  return (
    <div
      className="mention-unavailable"
      role="dialog"
      aria-label="Mention location unavailable"
      ref={host}
    >
      <strong>{reason}</strong>
      <p>{item.excerpt}</p>
      <button type="button" onClick={close}>
        Close
      </button>
    </div>
  );
}
let pending: InboxItem | undefined;
export function rememberTextMention(item: InboxItem) {
  pending = item;
}
export function takeTextMention(board: string, shape: string) {
  if (pending?.board_id !== board || pending.target_id !== shape) return;
  const item = pending;
  pending = undefined;
  return item;
}
